import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Search/+types/SearchPage";
import { fetchSearchPageData } from "@routes/Search/SearchPage.server";
import SearchPageContent from "@routes/Search/SearchPageContent";
import { SearchPageContext } from "@routes/Search/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /search route. */
const SearchPage = (): React.ReactElement => {
  const context = useLoaderData<SearchPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <SearchPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default SearchPage;

export const loader = async () => await fetchSearchPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as SearchPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: SearchPageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
